import { useEffect, useRef, useState } from "react";
import { fetchCuisineMasters } from "../../../Apiservices/Auth/servers/cateringPackageService";

const cuisineCache = new Map();

export const useCuisineMasters = (selectedMealId) => {
  const [cuisines, setCuisines] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const requestIdRef = useRef(0);

  useEffect(() => {
    const mealId = Number(selectedMealId);
    const requestId = ++requestIdRef.current;
    const controller = new AbortController();

    const cachedCuisines = cuisineCache.get(mealId) || [];
    setCuisines(cachedCuisines);
    setError("");

    if (!Number.isFinite(mealId) || mealId <= 0) {
      setLoading(false);
      return () => controller.abort();
    }

    const loadCuisines = async () => {
      setLoading(true);
      try {
        const result = await fetchCuisineMasters(mealId, { signal: controller.signal });
        cuisineCache.set(mealId, result);
        if (requestId === requestIdRef.current) setCuisines(result);
      } catch (requestError) {
        if (requestError?.code !== "ERR_CANCELED" && requestId === requestIdRef.current) {
          setError(requestError.message || "Unable to load cuisines.");
        }
      } finally {
        if (requestId === requestIdRef.current) setLoading(false);
      }
    };

    loadCuisines();
    return () => controller.abort();
  }, [selectedMealId]);

  return { cuisines, loading, error };
};
